export enum NotificationActionType {

  // Update
  UpdateNotification                    = 'UPDATE_NOTIFICATION',
  UpdateNotificationsReadState          = 'UPDATE_NOTIFICATIONS_READ_STATE',
  UpdateNotificationCompleted           = 'UPDATE_NOTIFICATION_COMPLETED',
  UpdateNotificationsReadStateCompleted = 'UPDATE_NOTIFICATIONS_READ_STATE_COMPLETED',
  UpdateNotificationFailed              = 'UPDATE_NOTIFICATION_FAILED',

  CreateNotificationTemplate            = 'CREATE_NOTIFICATION_TEMPLATE',
  UpdateNotificationTemplate            = 'UPDATE_NOTIFICATION_TEMPLATE',
  UpdateNotificationTemplateComplete    = 'UPDATE_NOTIFICATION_TEMPLATE_COMPLETE',
  UpdateNotificationTemplateFailed      = 'UPDATE_NOTIFICATION_TEMPLATE_FAILED',

  // Load
  LoadNotifications                   = 'LOAD_NOTIFICATIONS',
  LoadNotificationsCompleted          = 'LOAD_NOTIFICATIONS_COMPLETED',
  LoadNotificationsFailed             = 'LOAD_NOTIFICATIONS_FAILED',
  LoadNotificationTemplates           = 'LOAD_NOTIFICATION_TEMPLATES',
  LoadNotificationTemplatesCompleted  = 'LOAD_NOTIFICATION_TEMPLATES_COMPLETED',
  LoadNotificationTemplatesFailed     = 'LOAD_NOTIFICATION_TEMPLATES_FAILED',

  // Select
  SelectNotification          = 'SELECT_NOTIFICATION',
  SelectNotificationCompleted = 'SELECT_NOTIFICATION_COMPLETED',
  SelectNotificationFailed    = 'SELECT_NOTIFICATION_FAILED',

  // Delete
  DeleteNotification          = 'DELETE_NOTIFICATION',
  DeleteNotificationCompleted = 'DELETE_NOTIFICATION_COMPLETED',
  DeleteNotificationFailed    = 'DELETE_NOTIFICATION_FAILED',

  DeleteNotificationTemplate         = 'DELETE_NOTIFICATION_TEMPLATE',
  DeleteNotificationTemplateComplete = 'DELETE_NOTIFICATION_TEMPLATE_COMPLETE',
  DeleteNotificationTemplateFailed   = 'DELETE_NOTIFICATION_TEMPLATE_FAILED',

  // Send
  SendNotifications           = 'SEND_NOTIFICATIONS',
  SendNotificationsCompleted  = 'SEND_NOTIFICATIONS_COMPLETED',
  SendNotificationsFailed     = 'SEND_NOTIFICATIONS_FAILED',

}
